/** La rubrique dont relève une vue, et le slug si c'est une fiche. */
export function rubriqueDeLaVue(vue) {
    switch (vue.type) {
        case 'accueil':
            return { rubrique: 'accueil' };
        case 'artistes':
            return { rubrique: 'artistes' };
        case 'artiste':
            return { rubrique: 'artistes', slug: vue.slug };
        case 'expositions':
            return { rubrique: 'expositions' };
        case 'exposition':
            return { rubrique: 'expositions', slug: vue.slug };
        case 'foires':
            return { rubrique: 'foires' };
        case 'foire':
            return { rubrique: 'foires', slug: vue.slug };
        case 'oeuvres':
            return { rubrique: 'oeuvres' };
        case 'oeuvre':
            return { rubrique: 'oeuvres', slug: vue.slug };
        case 'actualites':
            return { rubrique: 'actualites' };
        case 'actualite':
            return { rubrique: 'actualites', slug: vue.slug };
        case 'la-galerie':
            return { rubrique: 'la-galerie' };
        case 'contact':
            return { rubrique: 'contact' };
        case 'mentions':
            return { rubrique: 'mentions' };
        case 'confidentialite':
            return { rubrique: 'confidentialite' };
        case 'plan-du-site':
            return { rubrique: 'plan-du-site' };
        case 'introuvable':
            return undefined;
    }
}
//# sourceMappingURL=vues.js.map